import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "effect-controls" }
const _hoisted_2 = { class: "effect-controls__container" }
const _hoisted_3 = {
  key: 0,
  class: "effect-controls__row effect-controls__audio-reactivity"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "effect-controls__control-name" }, "Audio reactive", -1)
const _hoisted_5 = { class: "effect-controls__toggle-wrapper" }
const _hoisted_6 = { class: "effect-controls__row effect-controls__intensity" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "effect-controls__control-name" }, "Intensity", -1)
const _hoisted_8 = { class: "effect-controls__slider-wrapper" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "effect-controls__divider" }, null, -1)
const _hoisted_10 = { class: "effect-controls__row effect-controls__layers" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "effect-controls__control-name" }, "Apply to", -1)
const _hoisted_12 = { class: "effect-controls__checkbox-groups" }

import { AvailableEffect, EffectGroup } from '@/static/effectName'
import Slider from '@/components/common/Slider.vue'
import Toggle from '@/components/common/Toggle.vue'
import Checkbox from '@/components/common/Checkbox.vue'
import EffectControlsPanelHeader from '@/components/effect/EffectControlsPanelHeader.vue'
import useEffect from '@/composables/UseEffect'
import { Layers } from '@/static/Layers'
import { useProjectStore } from '@/store/project-store'
import EffectsCarousel from '@/components/effect/EffectsCarousel.vue'

interface Props {
  effectGroup: EffectGroup,
  selectedAvailableEffect: AvailableEffect
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EffectControlsPanel',
  props: {
    effectGroup: null,
    selectedAvailableEffect: null
  },
  emits: ["selectEffect"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'selectEffect', effect: AvailableEffect): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  effectGroup: EffectGroup,
  selectedAvailableEffect: AvailableEffect
};

const { updateEffectLayer } = useEffect()
const projectStore = useProjectStore()





const layerDisabled = (layer: Layers) => { return props.selectedAvailableEffect.config.layers.indexOf(layer) === -1 }
const layerChecked = (layer: Layers) => { return projectStore.selectedEffect.appliedToLayer.indexOf(layer) !== -1 }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(EffectControlsPanelHeader),
    (__props.effectGroup.effects.length > 1)
      ? (_openBlock(), _createBlock(EffectsCarousel, {
          key: 0,
          class: "effect-controls__carousel",
          effects: __props.effectGroup.effects,
          "active-effect": __props.selectedAvailableEffect.name,
          onSelectEffect: _cache[0] || (_cache[0] = (effect) => emits('selectEffect', effect))
        }, null, 8, ["effects", "active-effect"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (__props.selectedAvailableEffect.config.isAudioReactive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(Toggle, {
                isOn: _unref(projectStore).selectedEffect.audioReactivityEnabled,
                "onUpdate:isOn": _cache[1] || (_cache[1] = ($event: any) => ((_unref(projectStore).selectedEffect.audioReactivityEnabled) = $event))
              }, null, 8, ["isOn"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Slider, {
            min: 0,
            max: 1,
            step: 0.01,
            modelValue: _unref(projectStore).selectedEffect.intensity,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(projectStore).selectedEffect.intensity) = $event))
          }, null, 8, ["step", "modelValue"])
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(Checkbox, {
          disabled: layerDisabled(_unref(Layers).BACKGROUND),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(updateEffectLayer)(_unref(Layers).BACKGROUND))),
          checked: layerChecked(_unref(Layers).BACKGROUND),
          text: "Background"
        }, null, 8, ["disabled", "checked"]),
        _createVNode(Checkbox, {
          disabled: layerDisabled(_unref(Layers).TEXT),
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_unref(updateEffectLayer)(_unref(Layers).TEXT))),
          checked: layerChecked(_unref(Layers).TEXT),
          text: "Text"
        }, null, 8, ["disabled", "checked"]),
        _createVNode(Checkbox, {
          disabled: layerDisabled(_unref(Layers).LOGO),
          onChange: _cache[5] || (_cache[5] = ($event: any) => (_unref(updateEffectLayer)(_unref(Layers).LOGO))),
          checked: layerChecked(_unref(Layers).LOGO),
          text: "Logo"
        }, null, 8, ["disabled", "checked"]),
        _createVNode(Checkbox, {
          disabled: layerDisabled(_unref(Layers).STICKER),
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_unref(updateEffectLayer)(_unref(Layers).STICKER))),
          checked: layerChecked(_unref(Layers).STICKER),
          text: "Sticker"
        }, null, 8, ["disabled", "checked"])
      ])
    ])
  ]))
}
}

})